import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { StayAndSavePromo } from "src/app/core/services/myqq";

@Component({
  selector: "myqq-stay-and-save-progress",
  standalone: true,
  imports: [CommonModule, MatCardModule, MatProgressBarModule],
  templateUrl: "./stay-and-save-progress.component.html",
  styleUrls: ["./stay-and-save-progress.component.scss"],
})
export class StayAndSaveProgressComponent {
  @Input()
  stayAndSaveDetail: StayAndSavePromo;
  plural: string = "";
  get progressValue(): number {
    if (!this.stayAndSaveDetail) {
      return 0;
    }
    return (
      ((this.stayAndSaveDetail.numDaysForPromo -
        this.stayAndSaveDetail.daysRemainingForPromo) /
        this.stayAndSaveDetail.numDaysForPromo) *
      100
    );
  }
  constructor() {}

  getMonth(value) {
    if (value > 1) {
      this.plural = "s";
    }
    return value;
  }

  ngOnInit(): void {}
}
